import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IAppState {
  openDialog: boolean;
  serverUrl: string;
  creer: boolean;
  userLoggedIn: boolean;
  goToParameter: boolean;
  goToTirage: boolean;
  goToDashbord: boolean;
}

export const appSlice: any = createSlice({
  name: "application",
  initialState: {
    openDialog: false,
    // serverUrl: "http://192.168.1.207:1976",
    serverUrl: "http://localhost:1976",
    // serverUrl: "",
    creer: false,
    userLoggedIn: false,
    goToParameter: false,
    goToTirage: false,
    goToDashbord: false,
  },

  reducers: {
    setServerUrl: (state, action: PayloadAction<string>) => {
      state.serverUrl = action.payload;
    },

    setOpenDialog: (state, action: PayloadAction<boolean>) => {
      state.openDialog = action.payload;
    },

    setCreer: (state, action: PayloadAction<boolean>) => {
      state.creer = action.payload;
    },

    setUserLoggedIn: (state, action: PayloadAction<boolean>) => {
      state.userLoggedIn = action.payload;
    },

    setGoToParameter: (state, action: PayloadAction<boolean>) => {
      state.goToParameter = action.payload;
    },

    setGoToTirage: (state, action: PayloadAction<boolean>) => {
      state.goToTirage = action.payload;
    },

    setGoToDashbord: (state, action: PayloadAction<boolean>) => {
      state.goToDashbord = action.payload;
    },
  },
});

export const {setGoToDashbord, setGoToTirage, setGoToParameter, setOpenDialog, setServerUrl, setCreer, setUserLoggedIn } = appSlice.actions;

export default appSlice.reducer;
